export const toastStyles = {
  borderRadius: 15,
}
